import { client, errorValidation } from "./service";

export const getProductList = async function ({
    skuId, productName, event, isActive
}) {
    try {
        let response = await client.get(`/po-product/list?skuId=${skuId || ''}&productName=${productName || ''}&event=${event || ''}&isActive=${isActive || ''}`)
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return errorValidation(e)
    }
}

export const getProductListv2 = async function ({
    skuId, productName, event, isActive, limit = 10000, page = 0
}) {
    try {
        let response = await client.get(`/po-product/list-v2?skuId=${skuId || ''}&productName=${productName || ''}&event=${event || ''}&isActive=${isActive || ''}&limit=${limit}&page=${page}`)
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return errorValidation(e)
    }
}

export const getProductDetail = async function ({
    id
}) {
    try {
        let response = await client.get(`/po-product/detail/${id}`)
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return errorValidation(e)
    }
}

export const createProduct = async function ({
    name, skuId, image, event, description, stock, price, qtyType, productVariantPrice, isActive
}) {
    try {
        let response = await client.post(`/po-product/create`, {
            name, skuId, image, event, description, stock, price, qtyType, productVariantPrice, isActive
        });
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        // return { error: e.response.data.errorCode }
        return errorValidation(e)
    }
}

export const updateProduct = async function ({
    _id, name, skuId, image, event, description, stock, price, qtyType, productVariantPrice, isActive
}) {
    try {
        let response = await client.post(`/po-product/update/${_id}`, {
            name, skuId, image, event, description, stock, price, qtyType, productVariantPrice, isActive
        });
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        // return { error: e.response.data.errorCode }
        return errorValidation(e)
    }
}

export const archiveProduct = async function ({
    productId
}) {
    try {
        let response = await client.get(`/po-product/archive/${productId}?isActive=false`);
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        // return { error: e.response.data.errorCode }
        return errorValidation(e)
    }
}